import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=48e7a19a&scoped=true&"
var script = {}
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=48e7a19a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7a19a",
  null
  
)

export default component.exports